<template>
  <div class="penthouse">
    <div class="view-section scrollFade">
      <div class="view-section--image penthouse-main-1" :style="{ backgroundImage: `url('${data[0].image}')` }"></div>
    </div>
<!--    <div class="penthouse-main">-->
<!--      <div class="penthouse-main__content">-->
<!--        <span class="penthouse-main__content&#45;&#45;title">ionecte LOLIIvolupiet LOLIIvolupietion</span>-->
<!--        <span class="penthouse-main__content&#45;&#45;description">-->
<!--          Lorem ipsconsectetur adipiscing elit. Nunc sollicitudin risus id leo luctus dapibus.-->
<!--          Integer in diam sit amet lacus mattis ornare. Suspendisse us id leo luctu potenti.-->
<!--          Aenean vestibulum Suspeorem ipsconsectetur adipisg elit. Nunc sollicitudin risus id leo luctus dapibus.-->
<!--          Intege id leo luctus eorem ipsconsectetur g elit. Nunc sollicitudin risus id leo luctus dapibus.-->
<!--          Integer in diam sit amet lacus mattis ornare.-->
<!--          Suspesg elit. Nunc sollicitudin risus id leo luctus dapibus. Intege id leo luctus eorem ipsconsectetur-->
<!--        </span>-->
<!--      </div>-->
<!--      <div class="penthouse-main__view">-->
<!--        <img src="../assets/penthouses/aerial.jpg" alt="Aerial" class="penthouse-main__view&#45;&#45;image">-->
<!--      </div>-->
<!--    </div>-->

    <!-- section image text -->
    <div class="left-section">
      <div class="left-section__view scrollFade">
        <div class="left-section__view--images penthouse-one" :style="{ backgroundImage: `url('${data[1].image}')` }"></div>
      </div>
      <div class="left-section__description reverse">
          <span class="left-section__description--text scrollFadeText">
            {{ data[1].text }}
          </span>
      </div>
    </div>

    <!-- section image text -->
<!--    <div class="left-section">-->
<!--      <div class="left-section__view">-->
<!--        <div class="left-section__view&#45;&#45;images penthouse-two"></div>-->
<!--      </div>-->
<!--      <div class="left-section__description reverse">-->
<!--          <span class="left-section__description&#45;&#45;text">-->
<!--          </span>-->
<!--      </div>-->
<!--    </div>-->

    <!-- section panorama -->
    <div class="penthouse-panorama scrollFade" id="lastSectionPenthouse">
      <img :src="data[2].image" alt="Panorama" class="penthouse-panorama--image">
    </div>
  </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'PageView',
        'pagePath': '/penthouse',
        'pageTitle': 'Parker West | Penthouse'
    })
    export default {
      name: "Penthouse",
      created() {
          if(window.innerWidth <= 600) {
              let myMain = document.getElementsByClassName('app-main')[0];
              myMain.scrollTop = 0;
          }
      },
        metaInfo: {
            // Define meta tags here.
            titleTemplate: '%s ← Penthouse',
            meta: [
                {name: 'description', content: 'Parkerwest penthouse page'},
                {name: 'viewport', content: 'width=device-width,initial-scale=1.0, maximum-scale=1.0,user-scalable=0'},
                {name: 'robots', content: 'index,follow'}
            ],
            link: [
                {rel: 'canonical', href: 'http://www.parkerwest.com/'}
            ]
        },
        mounted() {
        document.addEventListener('mousewheel', (e) => {
          this.handleScroll(e)
        }, { passive: false })
      },
      beforeDestroy () {
        document.removeEventListener('mousewheel', this.handleScroll);
        const elmnt = document.getElementsByTagName("html")[0];
        elmnt.classList.remove( 'disable' );
      },
      computed: {
        data() {
            return window.data.penthouse;
        },
      },
      methods: {
        handleScroll(evt) {
          const elmnt = document.getElementsByTagName("html")[0];
          if (!evt) evt = event;
          const direction = (evt.detail<0 || evt.wheelDelta>0) ? 1 : -1;
          // Use the value as you will
          const test = document.getElementById('lastSectionPenthouse')
          if (test) {
            if ((window.innerHeight + window.scrollY) >= elmnt.offsetHeight) {
              // you're at the bottom of the page
              if (direction === -1) {
                test.scrollLeft   += 30
              }
              if (direction === 1) {
                test.scrollLeft   -= 30
              }

              if (test.scrollLeft <= 0) {
                elmnt.classList.remove('disable' );
              } else {
                elmnt.classList.add( 'disable' );
              }
              return
            }
          }
          if (direction === 1) {
            elmnt.classList.remove('disable' );
          }

          let slidesTitle = document.getElementsByClassName("scrollFadeText");
            let slides = document.getElementsByClassName("scrollFade");

          for (let i = 0; i < slidesTitle.length; i++) {
            let elPos = slidesTitle[i].getBoundingClientRect().top
            if(elPos < 120) {
              slidesTitle[i].style.opacity = (elPos / 120)
            } else {
              slidesTitle[i].style.opacity = 1
            }
            if ((elPos - innerHeight) < innerHeight && slidesTitle[i].offsetHeight + elPos > innerHeight ) {
              slidesTitle[i].style.opacity = 1 - (elPos / innerHeight)
            }
          }
            if(window.innerWidth > 600) {
                for (let i = 0; i < slides.length; i++) {
                    let elPos = slides[i].getBoundingClientRect().top
                    const header = document.getElementById('header')
                    if ((elPos - innerHeight) < innerHeight && slides[i].offsetHeight + elPos > innerHeight ) {
                        slides[i].style.opacity = 1 - ((elPos - header.offsetHeight) / innerHeight)
                    }
                }
            }

        }
      }
    }
</script>

<style scoped>

</style>
